import React from "react";
import { valueToString} from "helpers/Helpers";
import classNames from "classnames";
import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";
import { formatReportCurrency } from "helpers/reportFormat";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
}

export default function ProductsTable(props: IProps) {

  function formatDisplay(type: string, value: string) {
    let newValue = value !== null && value !== undefined ? value : "";

    if (!isNaN(Number(newValue)) && newValue !== "") {
      switch (type) {
        case "currency":
          newValue = formatReportCurrency(value);
          break;
        case "decimal":
          newValue = Number(value).toFixed(2);
          break;
        case "percentage":
          newValue = `${Number(value) * 100}%`;
          break;
        default:
          break;
      }
    } else if (type === "string" && newValue !== "") {
      newValue = valueToString(value).replace(/(^\w|\s\w)/g, c => c.toUpperCase());
    }

    return newValue;
  }

  // Format cell data based on column
  function cellData(columnId: string, cellValue: string, displayType: string, cell: any) {
    switch (columnId) {
      case "tournament_name":
        return cell.row?.original?.tournament_name
          ? formatDisplay(displayType, cell.row?.original?.tournament_name as string)
          : cell.row?.original?.hospitality_event_name
            ? formatDisplay(displayType, cell.row?.original?.hospitality_event_name as string)
            : formatDisplay(displayType, cellValue);
      default:
        return formatDisplay(displayType, cellValue);
    }
  }

  function rowClassNames(row: any) {
    return classNames({
      "report-table-row":
        row.original?.type === "product" ||
        row.original?.type === "variant" ||
        !row.original?.type,
      "report-table-row-department":
        row.original?.type === "department",
      "report-table-row-category":
        row.original?.type === "category",
      "report-table-row-subcategory":
        row.original?.type === "subcategory",
    });
  }

  // Add on click events based on column
  function cellOnClick() {
    return {};
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    return classNames({
      "report-table-row-locked": isRowLocked,
    });
  }

  // Add footer data based on column
  function footerData(columnId: string, footerRow?: Record<string, any>) {
    if (!footerRow) {
      return null;
    }

    switch (columnId) {
      case "title":
        return footerRow?.title as string;

      default:
        return footerRow[columnId] as string ?? null;
    }
  }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={cellOnClick}
      cellData={cellData}
      rowClassNames={rowClassNames}
      cellClassNames={cellClassNames}
      footerData={footerData}
      expanding={true}
      expandingColumn="title"
    />
  );
}
